// extracted by mini-css-extract-plugin
export default {"ButtonIcon":"brFFOiXiOEgw5BeGVovg","Button":"Ze3L5TDd1MTjtWsRRoQq","Variant--light":"DTuGnl1WKyMu475BbUvg","Variant--dark":"BqI4GIbd_jtD7ZsMt6q5"};